import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'md-language-selector',
  standalone: true,
  imports: [CommonModule, MatSelectModule, MatFormFieldModule, FormsModule, TranslateModule],
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent {
  selectedLanguage: string;

  constructor(private translationService: TranslationService) {
    this.selectedLanguage = this.translationService.currentLang;
  }

  get languages(): string[] {
    return this.translationService.languages;
  }

  onLanguageChange(): void {
    this.translationService.useLanguage(this.selectedLanguage);
  }
}
